eshopApp.controller('AdditionalOrderDetailsController', ['$scope', '$http', '$rootScope', 'alertMessage', function($scope, $http, $rootScope, alertMessage){

    $rootScope.detailsSuccess = false;

    // Init function: Get and check current value
    $scope.init = function() {
        var is_admin = (parseInt($scope.is_admin) > 0);
        var current_value = $scope.additional_details.trim();
        if (is_admin) {
            // Admin user: details mandatory, perform checking
            $rootScope.detailsSuccess = (current_value !== '' && current_value !== null);
        } else {
            // Non-admin user: details not mandatory
            $rootScope.detailsSuccess = true;
        }
    };

	$scope.additional_details = null;

	// Set additional order details
	$scope.setAdditionalDetails = function() {
		$http.post('/a/set_additional_details', {
			additional_details : $scope.additional_details
		}).success(function(response) {
            if (response.message === 'success') {
			    alertMessage.set(response.alert, 'success');
                $rootScope.detailsSuccess = true;
            } else {
                alertMessage.set(generic.error, 'error');
            }
		}).error(function(){
            alertMessage.set(generic.error, 'error');
        });
	}

	// Event listener
    /*var setAdditionalOrderDetails = $rootScope.$on('setAdditionalOrderDetails', function(event, data){
    	$scope.setAdditionalDetails();
    });
    $scope.$on('$destroy', setAdditionalOrderDetails);*/

}]);
